export const toWellPrintedJSON = (value: any): string => {
  return JSON.stringify(value, undefined, 2);
};
